export default __webpack_public_path__ + "static/6-0b96da0ee2f069823d7be2c3815dfaef.jpg";